import { namespace as sessionNamespace, reducer as sessionReducer } from '@tgtg/core/session';
import { type Reducer } from 'redux';

import baseApiSlice from '../../api/baseApiSlice';
import logoutReducer from '../../features/logout/logoutReducer';
import intlNameSpace from '../intl/intlNameSpace';
import intlSlice from '../intl/intlSlice';

export function initReducers() {
  const reducer: { [namespace: string]: Reducer } = {};

  return {
    [baseApiSlice.reducerPath]: baseApiSlice.reducer,
    [intlNameSpace]: intlSlice,
    [sessionNamespace]: sessionReducer,
    logout: logoutReducer,
    ...reducer,
  };
}
